import {Button} from "@mui/material";
import EmailInput from "auth/EmailInput";
import PasswordInput from "auth/PasswordInput";
import {useLogInMutation} from "auth/api";
import {validatePassword} from "auth/utils/validators";
import {useAuth} from "hooks/useAuth";
import useForm, {type FieldConfig} from "hooks/useForm";
import type {FC} from "react";
import {handleMutation} from "services/http/utils";
import {validateEmail} from "utils/validators";

const LoginForm: FC = () => {
  const {setUser} = useAuth();
  const [logIn, {loading}] = useLogInMutation();

  const initialFields: Record<string, FieldConfig<any>> = {
    email: ["", v => validateEmail(v, true)],
    password: ["", validatePassword],
  };

  const {fields, handleSubmit} = useForm({
    fields: initialFields,
    onSubmit: async values => {
      const payload = {
        email: values.email,
        password: values.password,
      };

      await handleMutation(
        logIn,
        payload,
        "User logged in successfully",
        undefined,
        {
          onSuccess: user => setUser(user),
        },
      );
    },
  });

  return (
    <form onSubmit={handleSubmit} style={{width: "100%", maxWidth: 400}}>
      <EmailInput {...fields.email} />
      <PasswordInput label="Password" {...fields.password} />
      <Button
        type="submit"
        variant="contained"
        fullWidth
        size="large"
        loading={loading}
        sx={{mt: 2}}>
        Sign In
      </Button>
    </form>
  );
};

export default LoginForm;
